<script lang="ts">
    import { humanizedNumber } from 'hydria/utils/humanized_numbers'
    import { lg } from 'hydria/services/language'

    interface Props {
        value: number;
        decimals?: number;
        ifNull?: string | 0;
    }

    let { value, decimals = 3, ifNull = '–' }: Props = $props();

    let orders = $derived($lg == 'fr' ? ['o', 'ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'] : ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'])
</script>

{value == null && ifNull !== 0 ? ifNull : humanizedNumber(value == null ? 0 : value, decimals, 1024, orders, true, $lg)}
